import React from "react"
import * as S from "./elements"

interface Props extends React.SelectHTMLAttributes<HTMLSelectElement> {
  hasError?: boolean
}

export const Select: React.FC<Props> = ({ hasError, ...rest }) => {
  return <S.Select hasError={hasError} {...rest}></S.Select>
}
